export const trimString = (value) =>
  typeof value === 'string' ? value.trim() : value;
